export default __webpack_public_path__ + "static/media/camera-orientation-video.d67ce68a.mp4";